/**
 * Phase 46 (Plan 46-07) — Channel name label with hover tooltip.
 *
 * Consumed by NotificationRoutingMatrix headers + NotificationsAuditPage
 * rows + NotificationAuditDrawer detail. Renders the human label from
 * CHANNEL_LABELS and exposes the full tooltip copy via the `title` attribute.
 */
import {
  CHANNEL_LABELS,
  CHANNEL_TOOLTIPS,
  type Channel,
} from '../../constants/notificationEnums';

export interface ChannelLabelProps {
  channel: Channel;
  className?: string;
}

export function ChannelLabel({ channel, className = '' }: ChannelLabelProps) {
  return (
    <span className={className} title={CHANNEL_TOOLTIPS[channel]}>
      {CHANNEL_LABELS[channel].label}
    </span>
  );
}
